export function registerWithMist(){
    const statusElement = document.getElementById('statusElement');
    const spinner = document.getElementById('registerSpinner');
    const registerButton = document.getElementById('continue-btn');
    const searchParams = new URLSearchParams(window.location.search);

    // the relevant Mist variables needed to register are present in the URL of the current page (set by Mist)
    const wlan_id = searchParams.get("wlan_id");
    const ap_mac = searchParams.get("ap_mac");
    const client_mac = searchParams.get("client_mac");
    const url = searchParams.get("url");
    const ap_name = searchParams.get("ap_name");
    const site_name = searchParams.get("site_name");
    const authorize_url = searchParams.get("authorize_url");

    authData = {
        wlan_id: wlan_id,
        ap_mac: ap_mac,
        client_mac: client_mac,
        url: url,
        ap_name: ap_name,
        site_name: site_name,
        authorize_url: authorize_url
    }

    // hide register button and show spinner while attempt to authorize is made
    registerButton.style.display = 'none';
    spinner.style.display = 'block';

    // authorize
    fetch('/get-mist-auth-url', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(authData)
    })
    .then(response => response.json())
    .then(data => {
        if(data.success){
            // send browser to the returned Mist auth URL. If mist authorizes this, user is redirected and connected
            window.location.href = data.url;
        }
        else {
            spinner.style.display = 'none';
            registerButton.style.display = 'block';
            statusElement.textContent = 'Error connecting to WiFi.';
        }
    })
    .catch(err => {
        spinner.style.display = 'none';
        registerButton.style.display = 'block';
        console.error("Error during Mist authentication:", err);
        alert("Could not connect to WiFi, please try again.");
    });
}